import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@octano/global-ui';

import AdmissionProcessesFilter from './parts/AdmissionProcessesFilter';
import AdmissionProcessesList from './parts/AdmissionProcessesList';
import { AdmissionProcessesLoaderProvider } from './parts/loader';
import FormLoader from './parts/FormLoader';
import AdmissionProcessDetailsForm from './parts/AdmissionProcessDetailsForm';

interface ContentProps {
  data: {
    processTypes: {
      id: number;
      name: string;
      templateId?: number | null;
      templates?: { id: number; name: string }[];
    }[];
    periods: { id: number; name: string }[];
    paydays: { id: string; name: string }[];
  };
}

function AdmissionProcessesContent({ data }: ContentProps) {
  const { t } = useTranslation('academic-offer/admission-processes');
  const [selectedPeriodId, setSelectedPeriodId] = useState<number | null>(null);
  const [selectedProcessTypeId, setSelectedProcessTypeId] = useState<
    number | null
  >(null);
  const [activeParams, setActiveParams] = useState<{
    periodId: number;
    processTypeId?: number | null;
  } | null>(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleSearch = () => {
    if (selectedPeriodId) {
      setActiveParams({
        periodId: selectedPeriodId,
        processTypeId: selectedProcessTypeId,
      });
    }
  };

  const handleClear = () => {
    setSelectedPeriodId(null);
    setSelectedProcessTypeId(null);
    setActiveParams(null);
  };

  return (
    <>
      <p className="fs-16 mt-3 mb-4">{t('description')}</p>
      <AdmissionProcessesFilter
        periods={data.periods}
        processTypes={data.processTypes}
        selectedPeriodId={selectedPeriodId}
        selectedProcessTypeId={selectedProcessTypeId}
        onPeriodChange={setSelectedPeriodId}
        onProcessTypeChange={setSelectedProcessTypeId}
        onSearch={handleSearch}
        onClear={handleClear}
        onCreate={() => setIsCreateModalOpen(true)}
      />
      {activeParams && (
        <AdmissionProcessesLoaderProvider
          key={JSON.stringify(activeParams)}
          defaultQuery={activeParams}
          fetchImmediately
        >
          <AdmissionProcessesList />
        </AdmissionProcessesLoaderProvider>
      )}
      <Modal
        isOpen={isCreateModalOpen}
        toggle={() => setIsCreateModalOpen(!isCreateModalOpen)}
        size="lg"
      >
        <AdmissionProcessDetailsForm
          refresh={async () => {
            setIsCreateModalOpen(false);
            if (activeParams) {
              handleSearch();
            }
          }}
          periods={data.periods}
          processTypes={data.processTypes}
          paydays={data.paydays}
          defaultPeriodId={selectedPeriodId}
          onCancel={() => setIsCreateModalOpen(false)}
        />
      </Modal>
    </>
  );
}

export default function AdmissionProcesses() {
  return (
    <div className="mx-3">
      <div className="g-table-container mt-2 pb-4 pt-4">
        <FormLoader>
          {({ data }) => <AdmissionProcessesContent data={data} />}
        </FormLoader>
      </div>
    </div>
  );
}
